import { Box, Container, Typography, Grid, Chip, Stack, alpha, Button } from '@mui/material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import { useTenantConfig } from '../hooks/useTenant';

const P = {
    main: '#0891b2',
    light: '#06b6d4',
    dark: '#0e7490',
};



const S = { main: '#0891b2', light: '#22d3ee', dark: '#0e7490' };


const SectionBadge = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 14px',
    borderRadius: 50,
    background: 'rgba(8, 145, 178, 0.08)',
    border: '1px solid rgba(8, 145, 178, 0.15)',
    marginBottom: 20,
});

export default function OnlineMembershipSection() {
    const { tenantName, widget_video_url } = useTenantConfig();

    const navigate = useNavigate();
    return (
        <Box sx={{ py: { xs: 10, md: 14 }, bgcolor: '#fff' }}>
            <Container maxWidth="lg">
                <Grid container spacing={8} alignItems="center">
                    <Grid item xs={12} md={6}>

                        <SectionBadge>
                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: P.main }} />
                            <Typography sx={{ fontSize: '0.78rem', fontWeight: 600, color: P.main, letterSpacing: '0.4px' }}>
                                Üyelik Başvuru Sistemi
                            </Typography>
                        </SectionBadge>


                        <Typography variant="h3"
                            sx={{ fontWeight: 700, fontSize: { xs: '2.2rem', md: '2.8rem' }, color: '#1e293b', lineHeight: 1.25, letterSpacing: '-0.02em', mb: 2 }}>
                            Online Üyelik Sistemi ile <br />
                            <Box component="span" sx={{ color: S.main }}>Başvuruları Kolayca Yönetin</Box>
                        </Typography>
                        <Typography sx={{ fontSize: '1.05rem', color: '#475569', lineHeight: 1.8, mb: 3 }}>
                            {tenantName} Online Üyelik Başvuru Sistemi, dernek üyelik süreçlerinizi tamamen dijital ortama taşıyarak başvuruların hızlı, düzenli ve sorunsuz şekilde alınmasını sağlar.
                        </Typography>
                        <Typography sx={{ fontSize: '1.05rem', color: '#475569', lineHeight: 1.8, mb: 4 }}>
                            Web sitenize kolayca entegre edilen başvuru formu sayesinde, aday üyeler başvurularını birkaç adımda online olarak tamamlayabilir. Böylece tüm başvurular tek bir sistem üzerinden merkezi olarak yönetilir.
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate('/ozellikler/uye-yonetimi')}
                            sx={{
                                px: 4, py: 1.5, fontWeight: 600, fontSize: '1rem',
                                background: `linear-gradient(135deg, ${P.main} 0%, ${P.dark} 100%)`,
                                borderRadius: 2, textTransform: 'none',
                                boxShadow: `0 4px 16px ${alpha(P.main, 0.2)}`,
                                '&:hover': {
                                    background: `linear-gradient(135deg, ${P.dark} 0%, #155e75 100%)`,
                                    boxShadow: `0 8px 24px ${alpha(P.main, 0.3)}`,
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            Üye Yönetimi Modülünü İncele
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Stack spacing={3}>
                            {[
                                {
                                    color: '#10b981',
                                    title: 'Başvuru kaydı alınır',
                                    desc: 'Form doldurulur, sistem otomatik kayıt oluşturur.',
                                    image: '/assets/icon/attendance.webp'
                                },
                                {
                                    color: P.main,
                                    title: 'Gerekli kontroller yapılır',
                                    desc: 'Bilgiler doğrulanır, eksikler tespit edilir.',
                                    image: '/assets/icon/asset.webp'

                                },
                                {
                                    color: '#8b5cf6',
                                    title: 'Yönetici onayı ile tamamlanır',
                                    desc: 'Onaylandıktan sonra üyelik süreci başlar.',
                                    image: '/assets/icon/achievement.webp'
                                }
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', p: 2.5, borderRadius: 3, border: '1px solid #e2e8f0', bgcolor: '#ffffff' }}>
                                    <Box
                                        sx={{
                                            width: 52,
                                            height: 52,
                                            borderRadius: 2.5,
                                            background: `linear-gradient(135deg, ${S.main} 0%, ${S.light} 100%)`,
                                            boxShadow: `0 8px 20px ${alpha(S.main, 0.25)}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 2.5,
                                        }}
                                    >
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            style={{
                                                width: '60%',
                                                height: '60%',
                                                filter: 'brightness(0) invert(1)'
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={700} color="#0f172a" fontSize="0.95rem">{item.title}</Typography>
                                        <Typography variant="body2" color="#64748b">{item.desc}</Typography>
                                    </Box>
                                </Box>
                            ))}
                            <Box sx={{ mt: 1, p: 2.5, borderRadius: 3, bgcolor: alpha(P.main, 0.07), border: `1px solid ${alpha(P.main, 0.15)}` }}>
                                <Typography fontWeight={700} color={P.dark} mb={1}>Belgeler otomatik hazırlanır:</Typography>
                                <Stack spacing={0.5}>
                                    {['Derneğe özel üyelik formu', 'Başvuru çıktıları', 'PDF indirme & SMS/e-posta gönderimi'].map((t, i) => (
                                        <Stack key={i} direction="row" spacing={1} alignItems="center">
                                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: P.main, flexShrink: 0 }} />
                                            <Typography variant="body2" color="#334155">{t}</Typography>
                                        </Stack>
                                    ))}
                                </Stack>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
